import { Avatar, Grid } from "@etframework/ui.components";
import { ColumnDirective } from "@syncfusion/ej2-react-grids";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
/*
  Similar to the access modal grid but adapted to be managed by the form itself
*/
export const BoardPermissionsGrid = ({ onRemoveItems, ...rest }) => {
  const { t, i18n } = useTranslation(["CreateBoardModal", "Shared"]);

  const gridRef = useRef(null);

  const onRowSelected = () =>
    gridRef.current?.setToolbarItemVisibility(["deleteItem"], true, true);

  const onRowDeselected = (args, selectedCount) => {
    if (selectedCount === 0)
      gridRef?.current?.setToolbarItemVisibility(["search-input"], true, true);
    else if (selectedCount === 1) onRowSelected(args, selectedCount);
  };

  const searchSettings = {
    fields: ["Name", "FullName"],
    operator: "contains",
    ignoreCase: true,
    align: "Right"
  };

  const deleteToolbarItem = {
    align: "Left",
    type: "Button",
    id: "deleteItem",
    visible: false,
    text: t("Remove"),
    prefixIcon: `fa-regular fa-minus-circle`,
    click: () => {
      const selectedRecords = gridRef.current
        ?.getComponentRef()
        ?.getSelectedRecords();
      onRemoveItems?.(selectedRecords);
    }
  };

  const toolbarItems = [deleteToolbarItem];

  const nameTemplate = (props) => {
    return (
      <div className="d-flex align-items-center gap-3">
        <Avatar
          content={props.profileImage ?? props.FullName ?? props.Name}
        ></Avatar>
        <span>
          {props.currentUser ? t("Me", { name: props.Name }) : props.Name}
        </span>
      </div>
    );
  };

  return (
    <>
      <Grid
        {...rest}
        locale={i18n.language}
        id="create-board-grid-permission"
        ref={gridRef}
        toolbarItems={toolbarItems}
        showHeader={false}
        searchSettings={searchSettings}
        height="250px"
        allowFiltering={false}
        rowSelected={onRowSelected}
        rowDeselected={onRowDeselected}
        language={i18n.language}
      >
        <ColumnDirective
          field="PermissionType"
          visible={false}
          showInColumnChooser={false}
        />
        <ColumnDirective
          field="Id"
          visible={false}
          showInColumnChooser={false}
        />
        <ColumnDirective
          field="Name"
          headerText={t("UserOrGroup")}
          template={nameTemplate}
          filter={{
            type: "CheckBox"
          }}
        />
      </Grid>
    </>
  );
};
